import axios from "axios";
const API = axios.create({
  // baseURL: "https://ats-app-develop.makemycircle.com/api/", // for staging
  baseURL: `https://dronepad-api.alamanceinc.com/api/`, // for main
  // baseURL: "http://localhost:8000/api/", // for testing locally
});
export default API;
